import { useMemo } from 'react';
import * as S from '../PlacementsForm.styled';
import StartPauseBtn from './startPauseBtn/StartPauseBtn';
import { CopyString, EditPlacementModal } from 'components';
import { Start, Pause, Question } from 'assets/icons';
import { menuPlacementsActions } from 'constants';

//started,    =>   placement_status_id  = 3

//on pause,    =>   placement_status_id = 0

//archived   =>   placement_status_id = 9

const selectStatus = (status) => {
  switch (status) {
    case menuPlacementsActions.pause.value:
      return <Start />;
    case menuPlacementsActions.start_now.value:
      return <Pause />;
    default:
      return (
        <div className='question'>
          <Question />
        </div>
      );
  }
};

const SectionItem = ({ name, id, status, placementNames }) => {
  const namesWithoutCurrentName = useMemo(() => {
    return placementNames.filter((item) => item !== name);
  }, [name]);

  return (
    <S.TableRow>
      <S.TableCell>
        <S.TableContainer>
          <S.StartPauseBtnWrap>
            <StartPauseBtn placement_id={id} status={status} name={name} />
          </S.StartPauseBtnWrap>
          {selectStatus(status)}
          <S.TextWrap>
            <label>
              {name}
              <EditPlacementModal
                name={name}
                id={id}
                status={status}
                placementNames={namesWithoutCurrentName}
              />
            </label>
            <S.CopyIcon>
              <CopyString label='ID' text={id} />
            </S.CopyIcon>
          </S.TextWrap>
        </S.TableContainer>
      </S.TableCell>
    </S.TableRow>
  );
};

export default SectionItem;
